// import React from "react";
// import { FaPlay } from "react-icons/fa";
// import styled from "styled-components";

// const KeyManagement = () => {
//   const members = [
//     {
//       id: 1,
//       image: "/assets/images/about/user.png",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 2,
//       image: "/assets/images/about/user.png",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 3,
//       image: "/assets/images/about/user.png",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 4,
//       image: "/assets/images/about/user.png",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 5,
//       image: "/assets/images/about/img5.jpg",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 6,
//       image: "/assets/images/about/img5.jpg",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 7,
//       image: "/assets/images/about/img5.jpg",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//     {
//       id: 8,
//       image: "/assets/images/about/img5.jpg",
//       name: "Dr. Khairul Kabir",
//       designation: "Executive Director",
//       company: "Eque Group & Resort",
//     },
//   ];

//   return (
//     <Wrapper>
//       <section
//         className="rs-about-area section-space rs-about-thirteen"
//         style={{ paddingTop: "0", paddingBottom: "0" }}
//       >
//         <div className="container">
//           <div className="row g-5 justify-content-center section-title-space align-items-center">
//             <div className="col-xxl-6 col-xl-6 col-lg-6">
//               <div className="rs-section-title-wrapper text-center">
//                 <span className="rs-section-subtitle has-theme-orange">
//                   <FaPlay color="#EA5501" size={12} />
//                   Key
//                 </span>
//                 <h2 className="rs-section-title rs-split-text-enable split-in-fade">
//                   Management
//                 </h2>
//               </div>
//             </div>
//           </div>

//           <div className="grid">
//             {members.map((item) => (
//               <div className="card" key={item.id}>
//                 <div className="img-box">
//                   <img src={item.image} alt={item.name} />
//                 </div>

//                 <h4>{item.name}</h4>
//                 <span className="designation">{item.designation}</span>
//                 <p className="company">{item.company}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     </Wrapper>
//   );
// };

// const Wrapper = styled.section`
//   .grid {
//     display: grid;
//     grid-template-columns: repeat(4, 1fr);
//     gap: 25px;
//     /* margin-top: 20px; */
//   }

//   .card {
//     background: #fff;
//     padding: 20px;
//     text-align: center;
//     border-radius: 12px;
//     box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
//     transition: 0.3s ease;
//   }

//   .card:hover {
//     transform: translateY(-5px);
//   }

//   .img-box {
//     /* width: 120px; */
//     /* height: 120px; */
//     /* margin: 0 auto 15px; */
//     /* border-radius: 50%; */
//     /* overflow: hidden; */
//     /* border: 3px solid #f1f1f1; */
//   }

//   .img-box img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }

//   h4 {
//     font-size: 18px;
//     margin: 10px 0 5px;
//     font-weight: 600;
//   }

//   .designation {
//     display: block;
//     color: #555;
//     font-size: 14px;
//     margin-bottom: 5px;
//   }

//   .company {
//     font-size: 13px;
//     color: #888;
//   }

//   /* Responsive */
//   @media (max-width: 992px) {
//     .grid {
//       grid-template-columns: repeat(2, 1fr);
//     }
//   }

//   @media (max-width: 576px) {
//     .grid {
//       grid-template-columns: 1fr;
//     }
//   }
// `;

// export default KeyManagement;

import React from "react";
import styled from "styled-components";
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";

const teamData = [
  {
    id: 1,
    img: "assets/images/team/team-thumb-01.png",
    name: "Md. Rafe Uddin",
    designation: "ACMA: Group COO",
    company: "Finance Consultant",
    delay: ".3s",
  },
  {
    id: 2,
    img: "assets/images/team/team-thumb-02.png",
    name: "Md. Abdullah AL Mahmud",
    designation: "Group Head of Export",
    company: "Export Consultant",
    delay: ".5s",
  },
  {
    id: 3,
    img: "assets/images/team/team-thumb-03.png",
    name: "Md Abdul Alim",
    designation: "Production Head",
    company: "Eque Paper Mills Ltd",
    delay: ".7s",
  },
  {
    id: 4,
    img: "assets/images/team/team-thumb-01.png",
    name: "Md. Akramul Islam",
    designation: "GM",
    company: "Eque Paper Mills Ltd",
    delay: ".3s",
  },
  {
    id: 5,
    img: "assets/images/team/team-thumb-02.png",
    name: "Md. Abu Sayed",
    designation: "GM",
    company: "Eque Jute Process",
    delay: ".5s",
  },
  {
    id: 6,
    img: "assets/images/team/team-thumb-03.png",
    name: "Md. Masud Alam",
    designation: "GM",
    company: "Eque Hotel & resort",
    delay: ".7s",
  },
  {
    id: 7,
    img: "assets/images/team/team-thumb-01.png",
    name: "Md. Zahid Islam",
    designation: "GM",
    company: "Eque International",
    delay: ".3s",
  },
  {
    id: 8,
    img: "assets/images/team/team-thumb-02.png",
    name: "Md. Bipul",
    designation: "Head of Business",
    company: "Eque Enterprise",
    delay: ".5s",
  },
];

const KeyManagement = () => {
  return (
    <Wrapper>
      <section className="rs-team-area section-space-bottom rs-team-one">
        <div className="container">
          <div className="row g-5 justify-content-center section-title-space align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6">
              <div className="rs-section-title-wrapper text-center">
                <span className="rs-section-subtitle has-theme-orange">
                  <FaPlay color="#EA5501" size={12} />
                  Key
                </span>
                <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                  Management
                </h2>
              </div>
            </div>
          </div>

          {/* Section Title */}
          {/* <div className="row g-5 section-title-space align-items-center">
          <div className="col-xl-7 col-lg-7">
            <div className="rs-section-title-wrapper">
              <span className="rs-section-subtitle has-theme-orange justify-content-start">
                <sv
                  g
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="15"
                  viewBox="0 0 11 15"
                  fill="none"
                >
                  <path
                    d="M3.14286 10L0 15L8.78104e-07 0L3.14286 5V10Z"
                    fill="#EA5501"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.28571 10L3.14286 15L3.14286 10L4.71428 7.5L3.14286 5L3.14286 0L6.28571 5L6.28571 10ZM6.28571 10L7.85714 7.5L6.28571 5V0L11 7.5L6.28571 15V10Z"
                    fill="#EA5501"
                  />
                </sv>
                Engineer
              </span>
              <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                The Best Industry Expert
              </h2>
            </div>
          </div>
          <div className="col-xl-5 col-lg-5">
            <div className="rs-team-btn d-flex justify-content-lg-end">
              <Link
                className="rs-btn has-theme-orange has-icon has-bg"
                to="/team"
              >
                Become a Member
                <span className="icon-box">
                  <svg
                    className="icon-first"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                  >
                    <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z" />
                  </svg>
                  <svg
                    className="icon-second"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                  >
                    <path d="M31.71,15.29l-10-10L20.29,6.71,28.59,15H0v2H28.59l-8.29,8.29,1.41,1.41,10-10A1,1,0,0,0,31.71,15.29Z" />
                  </svg>
                </span>
              </Link>
            </div>
          </div>
        </div> */}

          {/* Team Members */}
          <div className="row g-5">
            {teamData.map((member) => (
              <div key={member.id} className="col-xl-3 col-lg-3 col-md-6">
                <div
                  className="rs-team-item wow fadeInUp"
                  data-wow-delay={member.delay}
                  data-wow-duration="1s"
                >
                  <div className="rs-team-thumb has-clip">
                    <Link to="/team-details">
                      <img src={member.img} alt={member.name} />
                    </Link>
                    {/* <div className="rs-theme-social rs-team-social has-transparent">
                    <Link to="#">
                      <i className="ri-twitter-x-line"></i>
                    </Link>
                    <Link to="#">
                      <i className="ri-facebook-fill"></i>
                    </Link>
                    <Link to="#">
                      <i className="ri-linkedin-fill"></i>
                    </Link>
                  </div> */}
                  </div>
                  <div className="rs-team-content-wrapper">
                    <div className="rs-team-content-box">
                      <h5 className="rs-team-title fs-2">
                        <Link to="/team-details">{member.name}</Link>
                      </h5>
                      <span className="rs-team-designation">
                        {member.designation}
                      </span>
                      <p className="company">{member.company}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section``;

export default KeyManagement;
